import { SEARCH_LIST_PREVIEW } from '@/store/types'

import axios from '@/store/axios'

const state = {
  searchLoading: false,
  searchTxt: '',
  searchType: '',
  searchTotalCount: 0,
  searchList: [],
  searchParam: {
    page: {
      pageNo: 1,
      pageRow: 15
    },
    search: {
      searchTp: 'SA',
      catgryTp: 'NS',
      searchCatgry: 'A',
      searchKeyword: '',
      searchTp2: ''
    }
  }
}

const getters = {
  getSearchTp: (state) => state.searchParam.search.searchTp,
  getsearchType: (state) => state.searchParam.search.searchTp2,
  getSearchTxt: (state) => state.searchParam.search.searchKeyword,
  getSearchTotalCount: (state) => state.searchTotalCount,
  getSearchList: (state) => state.searchList,
  getSearchLoading: (state) => state.searchLoading
}

const actions = {
  fetchSearchList: (
    { commit, state },
    { searchKeyword, pageNo = 1, searchTp = 'SA', searchTp2 }
  ) => {
    commit('requestSearch')
    commit('setSearchParam', { searchKeyword, pageNo, searchTp, searchTp2 })
    return new Promise((resolve, reject) => {
      axios
        .post(
          `book/search?pageNo=${state.searchParam.page.pageNo}&pageRow=${state.searchParam.page.pageRow}`,
          {
            page: state.searchParam.page,
            search: state.searchParam.search
          }
        )
        .then((res) => {
          commit('setSearchList', {
            // searchTxt: search.search.searchKeyword,
            searchInfo: res.data.page,
            searchList:
              res.data.page.totalCount === 0 ? [] : res.data.result.bookList
          })
          commit('responseSearch')
          resolve(res)
        })
        .catch((err) => {
          commit('responseSearch')
          reject(err)
        })
    })
  },
  [SEARCH_LIST_PREVIEW]: (
    { commit, state },
    { searchKeyword, pageNo = 1, searchTp = 'SA', searchTp2 }
  ) => {
    commit('setSearchParam', { searchKeyword, pageNo, searchTp, searchTp2 })
    return new Promise((resolve, reject) => {
      axios
        .post(`/book/search/preview?pageNo=1&pageRow=3`, {
          page: { pageNo: 1, pageRow: 3 },
          search: state.searchParam.search
        })
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}

const mutations = {
  requestSearch: (state) => {
    state.searchLoading = true
  },
  responseSearch: (state) => {
    state.searchLoading = false
  },
  setSearchParam: (state, { searchKeyword, pageNo, searchTp, searchTp2 }) => {
    if (searchKeyword || searchKeyword === '') {
      state.searchParam.search.searchKeyword = searchKeyword
    }
    if (searchTp2 || searchTp2 === '') {
      state.searchParam.search.searchTp2 = searchTp2
    }
    if (pageNo) {
      state.searchParam.page.pageNo = pageNo
    }
    if (searchTp) {
      state.searchParam.search.searchTp = searchTp
    }
  },
  setSearchList: (state, { searchTxt, searchInfo, searchList, searchType }) => {
    state.searchTxt = searchTxt
    state.searchType = searchType
    state.searchTotalCount = searchInfo.totalCount
    state.searchList = searchList
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
